import React from 'react';
import StaffLayout from './StaffLayout';
import SalesMetricsDashboard from './SalesMetricsDashboard';

export default function MarketingPage() {
  return <StaffLayout section="marketing"><SalesMetricsDashboard /></StaffLayout>;
}
